
import React from 'react';

interface DashboardHeaderProps {
  courierName: string;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({ courierName }) => {
  return (
    <div className="bg-card/40 backdrop-blur-sm p-4 sm:p-6 rounded-lg shadow-sm border border-border/40 animate-fade-in">
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight mb-1">Рабочий стол</h1>
      <p className="text-muted-foreground">
        Управление арендой велосипедов для курьеров
      </p>
      {courierName ? (
        <p className="text-sm mt-1">
          Привет, <span className="font-medium text-primary">{courierName}</span>!
        </p>
      ) : (
        <p className="text-sm text-muted-foreground mt-1">
          Пользователь не авторизован
        </p>
      )}
    </div>
  );
};
